import axios from "axios";

const API_URL = process.env.REACT_APP_HOST_API;

class AnexoService {

    async downloadAnexo(anexoId) {
        var url = `${API_URL}/v1/publico/anexo/${anexoId}/download`;
        return axios.get(url, {
            responseType: "blob"
        }); 
    }

    async visualizarAnexoFile(anexoId, nomeArquivo) {
        try {
            const response = await this.downloadAnexo(anexoId);
            const blob = response.data;
            
            const url = window.URL.createObjectURL(blob);
            const newWindow = window.open(url, '_blank');
            
            if (newWindow) {
                newWindow.document.title = nomeArquivo || `anexo_${anexoId}`;
            } else {
                throw new Error("Não foi possível abrir a nova janela. Verifique se o bloqueador de pop-ups está ativado.");
            }
        } catch (error) {
            throw new Error("Erro ao visualizar o anexo: " + error.message);
        }
    }

    async obterAnexoBase64(anexoId) {
        try {
            const response = await this.downloadAnexo(anexoId);
            const blob = response.data;
            
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const base64 = reader.result.split(',')[1];
                    resolve(base64);
                };
                reader.onerror = () => {
                    reject(new Error("Erro ao converter anexo para base64"));
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            throw new Error("Erro ao obter anexo: " + error.message);
        }
    }

    async deleteAnexo(anexoId) {
        var url = `${API_URL}/v1/publico/anexo/${anexoId}`;
        return axios.delete(url, {
            
        });
    }

}

export default new AnexoService();

